import React from 'react';
import '../App.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="company-info">
          <p className="company-name">주식회사 뻔</p>
          <div className="info-row">
            <p>대표자 : 최숙희</p>
            <p>Tel : 031-5183-5092</p>
            <p>E-mail : ffun@ffuntalk.com</p>
          </div>
          <div className="info-row">
            <p>사업자등록번호 : 526-86-03240</p>
          </div>
          <p>주소 : 경기도 화성시 동탄순환대로 823, 410호 (영천동, 에이팩시티)</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 